<template>
    <div id="app">
        <loading-progress-bar/>
        <div class="container">
            <headerBlock/>
            <router-view/>
            <startGame v-if="modalOpened"/>
            <footerBlock/>
            <notification_dispatcher/>
        </div>
    </div>
</template>

<script>
    import headerBlock from './components/headerBlock.vue'
    import footerBlock from './components/footerBlock.vue'
    import startGame from './components/startGame.vue'
    import loadingProgressBar from './elements/loading_progress_bar.vue'
    import notification_dispatcher from './elements/notification/notification_dispatcher.vue'
    import {mapGetters, mapMutations, mapState} from "vuex";
    import _throttle from 'lodash/throttle'

    export default {
        name: "Main",
        components:{
            headerBlock,
            footerBlock,
            startGame,
            notification_dispatcher,
            loadingProgressBar,
        },
        computed: {
            ...mapState('modal_instruction', ['modalOpened']),
        },
        methods: {
            resize: _throttle(function (event) {
                this.changeWindowWidth(event.target.innerWidth);
            }, 100),
            ...mapMutations('window',['changeWindowWidth'])
        },
        mounted(){
            window.addEventListener('resize', (event)=>{
               this.resize(event);
            }, {passive: true});
        }
    }
</script>
<style lang="scss">
    body{
        font-family: "Gilroy", sans-serif;
        background-color: $bg;

        ::selection{
            color: white;
            background-color: $blue;
        }
        .scroll-background-blocker{
            position: fixed;
            width: 0;
            top: 0;
            left: 0;
            background: rgba(black, 0.6);
            z-index: 75;
            backdrop-filter: blur(10px);
            opacity: 0;

            transition: $transition;
            transition-property: opacity;

            display: none;
            @include tablet{
                display: block;
            }
        }

        &:not(.show-grecaptcha-badge) {
            .grecaptcha-badge {
                visibility: hidden;
                opacity: 0;
            }
        }

        &.fixed-scroll{
            position: relative;
            overflow: hidden !important;

            .scroll-background-blocker{
                bottom: 0;
                right: 0;
                width: 100%;
                opacity: 1;

            }
        }
    }
    #app{
        min-height: 100vh;
        color: $text_gray;
        overflow: hidden;
    }
    ul, h1, h2, h3, h4, h5, h6{
        margin-bottom: 0;
    }
    button, input, a, span, select{
         font-family: "Gilroy", sans-serif;

         outline: none !important;
         transition: $transition;
     }
    select{
          border: none;
      }
    button{

        border: none;
        cursor: pointer;
    }
    input{

    }
    a{
        &, &:hover{
            text-decoration: none;
        }
    }
    h1, h2, h3, h6{
        font-weight: bold;
        //color: $text_light_gray;
        color: white;
    }
    h1{
        font-size: 24px;
        line-height: 30px;
    }
    h2{
        font-size: 20px;
        line-height: 25px;
        margin-bottom: 24px;

        @include mobile{
            font-size: 18px;
            line-height: 22px;
        }

    }
    h3{
        font-size: 18px;
        line-height: 22px;
    }
    h6{
        font-size: 16px;
        line-height: 19px;
    }
    ul{
        list-style: none;
        padding-left: 0;
    }
    .nowrap{
        white-space: nowrap;
    }
</style>
